import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NGXLogger } from 'ngx-logger';
import { ReplaySubject, Subject } from 'rxjs';
import { ConfirmDailogueComponent } from 'src/app/shared/components/dailogue/confirm-dailogue.component';
import { Api } from 'src/app/shared/constants/api';
import { Message } from 'src/app/shared/constants/message';
import { DataService } from 'src/app/shared/services/data.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { IDocumentMaster } from '../document.interface';

@Component({
    selector: 'app-document-form',
    templateUrl: './document-form.component.html',
    styleUrls: ['./document-form.component.less'],
    standalone: false
})
export class DocumentFormComponent implements OnInit {

  documentMasterForm: FormGroup;
  isEditedData:boolean;
  showStatus:string;
  nDestroy = new Subject<void>();
  filteredVesselOperator:ReplaySubject<IDocumentMaster[]> = new ReplaySubject<IDocumentMaster[]>(1);

  constructor(private formBuilder: FormBuilder,
              private dailogRef : MatDialogRef<DocumentFormComponent>,
              private dailog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private utilityService: UtilityService,
              private service:DataService,
              private logger: NGXLogger
  ) { }

  ngOnInit(): void {
    this.initializeDocumentForm();
    this.patchValue();
  }

  private initializeDocumentForm(){
		this.documentMasterForm = this.formBuilder.group({
      id:[],
      code:[null,[Validators.required]],
      name:[null,[Validators.required]],
		});
 	}

  public cancel() {
    if(this.documentMasterForm.dirty){
      this.isEditedData=false;
      this.id.value?this.openDailog(Message.CANCEL_OPEN_DAILOG_IN_EDIT):
          this.openDailog(Message.CANCEL_OPEN_DAILOG)
    }else{
        this.dailogRef.close();
    }  
  }

  public onSave(){
    if(this.documentMasterForm.dirty && this.documentMasterForm.valid){
      this.isEditedData=true;
      this.id.value ? this.openDailog(Message.SAVE_OPEN_DAILOG_IN_EDIT):
      this.openDailog(Message.SAVE_OPEN_DAILOG);
    }
  }

  public save() {  
    this.documentMasterForm.markAllAsTouched();
    let method = this.id.value ? 'put' : 'post';
    let message= this.id.value ?'updated':'saved';
    this.logger.info('form value ',this.documentMasterForm.value)
    if(this.documentMasterForm.valid){
        this.service[method](Api.DOCUMENT_MASTER, this.documentMasterForm.value).subscribe(res => {
          this.utilityService.notifier('Document master '+message+' successfully', 'success');
          this.dailogRef.close();
      });
    }
  }

  openDailog(message:string){ 
    const dailogRef=this.dailog.open(ConfirmDailogueComponent,{
        data:message,
        maxWidth:"300px",
        maxHeight:"150px"
      });
    
    dailogRef.afterClosed().subscribe(dailogResult => {
        if(dailogResult===false){
          return;
        }
        else {
          if(!this.isEditedData) {
            this.dailogRef.close();
          }else{
             this.save();
          }       
        }
    });
  }
    
  private patchValue() {
    if (this.data?.id) {
      this.documentMasterForm.patchValue(this.data);
    }
  }

  get id(){ return this.documentMasterForm.get('id') };
  get name(){ return this.documentMasterForm.get('name') };
  get code(){ return this.documentMasterForm.get('code') };
 
}
